import {first} from "lodash";
import {joinTileRequest, selectTile} from "modules/actions";
import {
	getFantasyTiles,
	getFullFantasyEvent,
	getFullTeam,
	getParticipatedTiles,
	getSelectedTile,
	getTileById,
} from "modules/selectors";
import React, {PropsWithChildren, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useParams} from "react-router-dom";

export const SwingsSelector: React.FC<PropsWithChildren> = ({children}) => {
	const dispatch = useDispatch();
	const params = useParams();
	const location = useLocation();
	const tileId = params.tileId ? Number(params.tileId) : undefined;
	const tile = useSelector(getTileById)(tileId);
	const swings = useSelector(getParticipatedTiles);
	const selectedTile = useSelector(getSelectedTile);
	const tiles = useSelector(getFantasyTiles);
	const fullTeam = useSelector(getFullTeam);
	const fullFantasyTile = useSelector(getFullFantasyEvent);
	const isTeamPage = location.pathname.includes("/team");

	useEffect(() => {
		if (!isTeamPage || !fullTeam || !fullFantasyTile) {
			return;
		}

		const isJoinedFullFantasy = fullTeam.tiles.some(({id}) => id === fullFantasyTile.id);

		if (!tileId && !isJoinedFullFantasy) {
			dispatch(joinTileRequest(fullFantasyTile.id));
		}
	}, [tile, tileId, isTeamPage, fullTeam, fullFantasyTile, dispatch]);

	useEffect(() => {
		if (selectedTile || !tiles.length) {
			return;
		}
		if (tile) {
			dispatch(selectTile(tile.id));
			return;
		}
		const participatedSwing = first(swings);
		if (participatedSwing) {
			dispatch(selectTile(participatedSwing.id));
		}
	}, [selectedTile, tiles, swings, tile, dispatch]);

	useEffect(() => {
		if (tile) {
			dispatch(selectTile(tile.id));
		}
	}, [dispatch, tile]);

	return <React.Fragment>{children}</React.Fragment>;
};
